

import { 
  liveDeviceStatistics, 
  liveAcademyStatistics, 
  liveLeaderTypeStat,
  historyOnlineNum,
  liveWatchTimeDistribute
} from "@/api/resourceService"
import { 
  academyStatistics, 
  deviceStatistics, 
  leaderTypeStatistics, 
  liveTimeStatistics 
} from "./constant";

export function getWatchTimeStatistics(uuid) {
  return new Promise((resolve) => {
    liveWatchTimeDistribute(uuid).then( res => {
      const {code = 0, data = []} = res || {};
      if (code == 0 && data.length > 0) {
        resolve(data)
      } else {
        resolve(liveTimeStatistics)
      }
    }).catch(_ => {
      resolve(liveTimeStatistics)
    })
  })
}

export function getLiveDeviceStatistics(uuid) {
  return new Promise((resolve) => {
    liveDeviceStatistics(uuid).then( res => {
      const {code = 0, data = []} = res || {};
      if (code == 0 && data.length > 0) {
        resolve(data)
      } else {
        resolve(deviceStatistics)
      }
    }).catch(_ => {
      resolve(deviceStatistics)
    })
  })
}

export function getLeaderTypeStatistics(uuid) {
  return new Promise((resolve) => {
    liveLeaderTypeStat(uuid).then( res => {
      const {code = 0, data = []} = res || {};
      if (code == 0 && data.length > 0) {
        resolve(data)
      } else {
        resolve(leaderTypeStatistics)
      }
    }).catch(_ => {
      resolve(leaderTypeStatistics)
    })
  })
}

export function getAcademyStatistics(uuid) {
  return new Promise((resolve) => {
    liveAcademyStatistics(uuid).then( res => {
      const {code = 0, data = []} = res || {};
      if (code == 0 && data.length > 0) {
        resolve(data)
      } else {
        resolve(academyStatistics)
      }
    }).catch(_ => {
      resolve(academyStatistics)
    })
  })
}


export function getHistoryOnlineNum(params) {
  return new Promise((resolve) => {
    historyOnlineNum(params).then( res => {
      const {code = 0, data = {}} = res || {};
      if (code == 0 && data.onlineNumList) {
        resolve(data.onlineNumList || [])
      } 
      // else {
      //   resolve(academyStatistics)
      // }
    }).catch(_ => {
      // resolve(academyStatistics)
    })
  })
}






